import React__default from 'react';
import classnames from 'classnames';
import { getSelectionBoxStyles } from '@grandvisionhq/elements';

const SelectToggleButton = ({ name , children , isSelected , onItemClick , className  })=>{
    const handleClick = ()=>{
        onItemClick();
    };
    const classNames = getSelectionBoxStyles({
        isSelected,
        isDisabled: false,
        className
    });
    return /*#__PURE__*/ React__default.createElement("button", {
        className: classnames('select-toggle-button', classNames),
        onClick: handleClick,
        "aria-pressed": isSelected,
        name: name
    }, children);
};

export { SelectToggleButton };
//# sourceMappingURL=SelectToggleButton.js.map
